import { render, staticRenderFns } from "./TransferMoneyAgent.vue?vue&type=template&id=d44030fa&scoped=true&"
import script from "./TransferMoneyAgent.vue?vue&type=script&lang=js&"
export * from "./TransferMoneyAgent.vue?vue&type=script&lang=js&"
import style0 from "./TransferMoneyAgent.vue?vue&type=style&index=0&id=d44030fa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d44030fa",
  null
  
)

export default component.exports